export default "__VITE_ASSET__cff46bfe__"